<div class="access-denied-container">
  <div class="icon">
    <i class="fa-solid fa-lock"></i>
  </div>

  <h1 class="title">Access Denied</h1>
  <p class="message">
    You don’t have permission to view this page.<br />
    Please contact your administrator if you believe this is an error.
  </p>
  <p-button label="Go back home" styleClass="p-button-sm primary" (onClick)="goBack()"
            icon="pi pi-home" class="primary" >
  </p-button>
</div>
